'use client';

import './tooltip-info.scss';

import React from 'react';

import { ArkIcon } from '@sola/ark-icons/lib/ark-icon.tsx';
import { IconNames } from '@sola/schema/lib/icons/icon-names.ts';

import { cn } from '../../utils/helpers.ts';
import {
  Tooltip,
  TooltipContent,
  TooltipContentProps,
  TooltipProps,
  TooltipTrigger,
} from '../tooltip/tooltip';

export interface TooltipInfoProps
  extends
    Pick<TooltipProps, 'isDefaultOpen' | 'isOpen' | 'onOpenChange'>,
    Omit<TooltipContentProps, 'children' | 'className'> {
  children: React.ReactNode;
  triggerLabel?: string;
  triggerClassName?: string;
  contentClassName?: string;
  iconName?: IconNames;
  iconSize?: string;
}

export const TooltipInfo = ({
  children,
  triggerLabel = 'Additional information',
  triggerClassName,
  contentClassName,
  iconName = 'info-circle',
  iconSize,
  isDefaultOpen,
  isOpen,
  onOpenChange,
  align,
  side,
  size,
  alignOffset,
  sideOffset,
  fitContent,
  usePortal,
  ...props
}: TooltipInfoProps) => {
  return (
    <Tooltip
      isDefaultOpen={isDefaultOpen}
      isOpen={isOpen}
      onOpenChange={onOpenChange}
    >
      <TooltipTrigger>
        <button
          type="button"
          className={cn('TooltipInfo', triggerClassName)}
          aria-label={triggerLabel}
        >
          <ArkIcon
            iconName={iconName}
            {...(iconSize ? { size: iconSize } : {})}
          />
        </button>
      </TooltipTrigger>
      <TooltipContent
        {...props}
        align={align}
        side={side}
        size={size}
        alignOffset={alignOffset}
        sideOffset={sideOffset}
        fitContent={fitContent}
        usePortal={usePortal}
        className={contentClassName}
      >
        {children}
      </TooltipContent>
    </Tooltip>
  );
};
